export var disabledStyle = {
    opacity: 0.45,
    cursor: 'not-allowed',
};
export var fittedStyle = {
    margin: 0,
};
export var truncateStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
